import { Component, OnInit } from '@angular/core';
import { BaseLoginComponent } from 'src/app/shared/components/base-login/base-login.component';

@Component({
  selector: 'app-sgzp-app2dxsales-login',
  templateUrl: './sgzp-app2-dxsales-login.component.html',
  styleUrls: ['./sgzp-app2-dxsales-login.component.css', '../style/global.css'],
})
export class SgzpApp2DxsalesLoginComponent
  extends BaseLoginComponent
  implements OnInit
{
  async init(): Promise<void> {}
}
